module.exports = __webpack_public_path__ + "static/gsf_illustration_circle-5242d1969f0248d325d8e58e6ee5aef1.png";